import { FC } from "react"

interface ILabel {
  htmlFor: string
  label: string
  optional?: boolean
}

const Label: FC<ILabel> = (props) => {
  return (
    <label htmlFor={props.htmlFor}> 
      {props.label}
      {props.optional && <span className="optional" />}
    </label>
  )
}

export default Label
